import CardsPage from "../../components/CardsPage/CardsPage";
import { items } from "../../data/routes";

const HelpCenter = () => {
  return (
    <CardsPage
      items={items.find((item) => item.title === "Help center").childrens}
    />
  );
};

export default HelpCenter;
